<script>
import store from "@/store";
import http from "@/http";
import {ElNotification} from "element-plus";
import moment from "moment";

export default {
  name: "MobileMonitoringReport",
  data() {
    return {
      loading: false,
      boards: [],
      board: null,
      tableData: [],
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      period: moment(new Date()).format('YYYY-MM')
    }
  },
  computed: {
    store() {
      return store
    }
  },
  methods: {
    getBoardList() {
      this.$http
          .get("api/v1/boards")
          .then(({data}) => {
            this.boards = data.boards;
          })
          .catch(() => {
          });
    },
    downloadAllAsExcel() {
      this.loading = true;

      http
          .get(`api/v1/initiatives/mobile-monitoring/excel`, {
            params: {
              board_id: this.board,
              period: this.period
            },
            responseType: "blob",
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(() => {
            ElNotification({
              title: "Ogohlantirish",
              message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });

    },
    // getMobileMonitoringList() {
    //   this.loading = true;
    //   this.$http
    //       .get("/api/v1/initiatives/mobile-monitoring", {
    //         params: {
    //           limit: 10,
    //           offset: 0
    //         }
    //       })
    //       .then(({data}) => {
    //         this.tableData = data.monitorings;
    //       })
    //       .catch(({response}) => {
    //         ElNotification.error({
    //           message:
    //               response.data.message ||
    //               "Ma'lumot yuklashda xatolik sodir bo'ldi!",
    //         });
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    // },
  },
  mounted() {
    this.getBoardList();
    // this.getMobileMonitoringList()
  }
}
</script>

<template>
  <div class="mobile-monitoring">
    <div class="header">
      <el-select
          v-model="board"
          style="width: 250px"
          placeholder="Doskani tanlang"
      >
        <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
        />
      </el-select>
      <el-date-picker
          v-model="period"
          type="month"
          style="width: 150px"
          value-format="YYYY-MM"
          placeholder="Oyni tanlang"
      />
      <el-button
          class="upload-demo"
          type="success"
          style="margin-right: 10px"
          @click="downloadAllAsExcel"
      >
        <img
            style="margin-right: 10px"
            alt=""
            src="@/assets/images/icons/download.svg"
        />
        Yuklab olish
      </el-button>
    </div>
    <!--    <div class="info-wrapper">-->
    <!--      <el-table :data="tableData" border height="calc(100vh - 250px)">-->
    <!--        <el-table-column label="T/r" type="index" align="center"/>-->
    <!--        <el-table-column prop="moderator_fullname" min-width="140" label="Moderator"/>-->
    <!--        <el-table-column prop="address_title" min-width="140" label="Manzil"/>-->
    <!--        <el-table-column prop="comment" min-width="80" label="Izoh">-->
    <!--          <template v-slot="scope">-->
    <!--            <el-popover-->
    <!--                placement="top-start"-->
    <!--                title="Izoh"-->
    <!--                :width="200"-->
    <!--                trigger="hover"-->
    <!--                :content="scope.row.comment"-->
    <!--            >-->
    <!--              <template #reference>-->
    <!--                <span>{{ scope.row.comment.substring(0, 10) + '...' }}</span>-->
    <!--              </template>-->
    <!--            </el-popover>-->
    <!--          </template>-->
    <!--        </el-table-column>-->
    <!--        <el-table-column style="z-index: 999" prop="icon" label="Rasmlar" min-width="80" align="center">-->
    <!--          <template v-slot="scope">-->
    <!--            <el-image-->
    <!--                style="width: 50px; height: 50px"-->
    <!--                :src="baseUrl+scope.row.images[0]"-->
    <!--                :zoom-rate="1.2"-->
    <!--                :preview-src-list="scope.row.images.map(hash=>baseUrl+hash)"-->
    <!--                fit="cover"-->
    <!--            />-->
    <!--          </template>-->
    <!--        </el-table-column>-->
    <!--        <el-table-column v-if="$store.state.role === 'admin'"-->
    <!--                         fixed="right"-->
    <!--                         label=""-->
    <!--                         width="115"-->
    <!--                         align="center">-->
    <!--          <template #default="scope">-->
    <!--            <el-button-->
    <!--                type="primary"-->
    <!--                size="small"-->
    <!--                @click="$router.push({-->
    <!--                name: 'MobileMonitoringFormEdit',-->
    <!--                params: { id: scope.row.id },-->
    <!--              })-->
    <!--            "-->
    <!--            >-->
    <!--              <img height="15" src="@/assets/images/icons/edit.svg" alt="action"/>-->
    <!--            </el-button>-->
    <!--            <el-button-->
    <!--                type="danger"-->
    <!--                size="small"-->
    <!--                @click="onClickDelete(scope.row.id)"-->
    <!--            >-->
    <!--              <img height="15" src="@/assets/images/icons/delete.svg" alt="action"/>-->
    <!--            </el-button>-->
    <!--          </template>-->
    <!--        </el-table-column>-->
    <!--      </el-table>-->
    <!--    </div>-->
  </div>
</template>

<style scoped>
.header {
  display: flex;
  gap: 20px;
}

.info-wrapper {
  margin-top: 20px;
}
</style>
